import React, { useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import XLRLogger from 'src/common/helpers/logger';
import { styles } from './styles';
import { ReactComponent as AccountSelectionIcon } from '../../../common/media/Cash_Office_Account_Selection.svg';

const CashOfficeTitle: React.FC<ITenderCountProps> = ({
  title,
  totalSubtitleText,
  totalCountAmount,
  accountName,
}): JSX.Element => {
  const classes = styles();

  useEffect((): void => {
    XLRLogger.debug({
      message: `Cash Office Activity: ${title}`,
      source: 'components/cash-office-title.tsx',
    });
  }, [title]);

  return (
    <Grid
      container
      data-testid='cash-office-title'
      direction='column'
      className={`${classes.cashOfficeTitleContainer} fullWidth`}
    >
      <Grid item xs={8} style={{ height: 'fit-content' }}>
        <Grid
          container
          data-testid='cash-office-title-bar-container'
          direction='column'
          className={`${classes.cashOfficeTitleContainer} fullWidth`}
        >
          <Typography
            className={`${classes.cashOfficeTitleHeader} ${classes.cashOfficeTitleHeaderLabel}`}
            data-testid='cash-office-title-bar-text'
          >
            {title}
          </Typography>

          <Grid item xs={1}>
            <Typography className={`${classes.tenderPickupSubHeader}`}></Typography>
          </Grid>

          {accountName && (
            <>
              <Grid item xs={1} className={`${classes.cashOfficeTitleAccountHeaderLabel}`}>
                <AccountSelectionIcon className={`${classes.icon}`} />
              </Grid>
              <Grid className='fullWidth' direction='column'>
                <Typography
                  className={`${classes.cashOfficeTitleHeader} ${classes.cashOfficeTitleAccountHeaderLabel}`}
                  data-testid='cash-office-title-account-text'
                >
                  {accountName}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={8} style={{ height: 'fit-content' }}>
        <Grid
          container
          data-testid='cash-office-title-bar-amount-container'
          direction='column'
          className={`${classes.cashOfficeTitleContainer} fullWidth`}
        >
          <Grid item>
            <Typography
              className={`${classes.cashOfficeTitleHeader} ${classes.amountHeaderLabel}`}
              data-testid='cash-office-title-amount'
            >
              {totalCountAmount !== undefined && convertCurrency(totalCountAmount)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className={`${classes.amountSubHeader} ${classes.amountHeaderDesc}`}
              data-testid='cash-office-title-subtitle-text'
            >
              {totalSubtitleText}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface ITenderCountProps {
  title: string;
  totalSubtitleText?: string;
  totalCountAmount?: number;
  accountName?: string;
}

export default CashOfficeTitle;
